import { isSameDay } from "date-fns";
import { TimeObjToDate } from "./timeObjToDate";

export const DayWithinRange = ({ tStart, tEnd, day }) => {
  const start = TimeObjToDate(tStart);
  const end = TimeObjToDate(tEnd);
  return (start < day && day < end) || (start < day && isSameDay(day, end));
};
